/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, since: "false" | "true" }} DisconnectedInputs */



/**
* | since | output |
* | --- | --- |
* | "false" | "Offline" |
* | "true" | "Offline since {date}" |
*
* @param {DisconnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const disconnected = /** @type {((inputs: DisconnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DisconnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Offline`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Offline since ${i?.date}`);
		return /** @type {LocalizedString} */ ("disconnected");
	}
	{
		if (i?.since === "false") return /** @type {LocalizedString} */ (`Déconnectée`);
		if (i?.since === "true") return /** @type {LocalizedString} */ (`Déconnectée depuis le ${i?.date}`);
		return /** @type {LocalizedString} */ ("disconnected");
	}
});